import SetupRoute from 'cio/pods/base/setup/index/route';
export default SetupRoute;
